import { render, staticRenderFns } from "./JSelectXiaoqu.vue?vue&type=template&id=041f4b66&scoped=true"
import script from "./JSelectXiaoqu.vue?vue&type=script&lang=js"
export * from "./JSelectXiaoqu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f4b66",
  null
  
)

export default component.exports